import { z } from "zod";
const playbookNodeSampleToolResultIdSchema = z.uuid().brand();
function asPlaybookNodeSampleToolResultId(id) {
  return playbookNodeSampleToolResultIdSchema.parse(id);
}
function isSectionSampleToolResultData(data) {
  return data.kind === "existing_section" || data.kind === "new_section";
}
function isCriterionSampleToolResultData(data) {
  return data.kind === "existing_criterion" || data.kind === "new_criterion";
}
function isOutcomeSampleToolResultData(data) {
  return data.kind === "outcome";
}
function isSectionSampleToolResultPayload(payload) {
  return payload.kind === "existing_section" || payload.kind === "new_section";
}
function isOutcomeSampleToolResultPayload(payload) {
  return payload.kind === "outcome";
}
export {
  asPlaybookNodeSampleToolResultId,
  isCriterionSampleToolResultData,
  isOutcomeSampleToolResultData,
  isOutcomeSampleToolResultPayload,
  isSectionSampleToolResultData,
  isSectionSampleToolResultPayload,
  playbookNodeSampleToolResultIdSchema
};
//# sourceMappingURL=playbookNodeSampleToolResult.js.map
